import { Carousel } from '@mantine/carousel';
import AutoPlay from 'embla-carousel-autoplay';
import { useMediaQuery } from '@mantine/hooks';
import { Skeleton, useMantineTheme } from '@mantine/core';
import React, { useRef } from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { LogoIcon } from 'assets/Icons';
import { TopVendorSection, VendorCard } from './styles';
import { getAllVendors } from 'network/services/vendors';
import { CATEGORIES, SUPERMARKET } from 'navigation/routes';
import { userLocationAtom } from 'store/atoms/userLocationAtom';
import QUERY_KEYS from 'network/config/queryKeys';

export const VendorsGrid: React.FunctionComponent = () => {
  const userLocation = useRecoilValue(userLocationAtom);
  const { data, isLoading, refetch } = useQuery([QUERY_KEYS.VENDORS, userLocation?.address.state], () =>
    getAllVendors(userLocation?.address.state)
  );
  const theme = useMantineTheme();
  const mobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  const tablet = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);

  const autoplay = useRef(AutoPlay({ delay: 4000 }));
  const vendors = data?.data ? data.data.filter(item => item.category && item.category.length > 0) : [];

  React.useEffect(() => {
    refetch();
  }, [userLocation, refetch]);

  return (
    <TopVendorSection>
      <div className="top">
        <h2 className="title">Top Vendors</h2>
        {userLocation && <span>{`around \`${userLocation.address.state}\``}</span>}
      </div>
      <div className="content">
        <Carousel
          className="carousel"
          loop
          w={'100%'}
          slidesToScroll={mobile ? 1 : tablet ? 2 : 5}
          slideSize={mobile ? '90%' : tablet ? '20%' : '20%'}
          slideGap="md"
          plugins={[autoplay.current]}
          onMouseEnter={autoplay.current.stop}
          onMouseLeave={autoplay.current.reset}>
          {isLoading
            ? Array(7)
                .fill(0)
                .map((_, id) => (
                  <Carousel.Slide key={id}>
                    <Skeleton height={200} width={400} />
                  </Carousel.Slide>
                ))
            : vendors.map((vendor, id) => (
                <Carousel.Slide key={id}>
                  <Link to={`${CATEGORIES}${SUPERMARKET}?vendorId=${vendor.vendorId}`}>
                    <VendorCard>
                      <div className="img">
                        {vendor.profilePicture ? (
                          <img className="vendor-img" src={vendor.profilePicture} alt="vendor" />
                        ) : (
                          <LogoIcon className="icon" />
                        )}
                      </div>
                    </VendorCard>
                  </Link>
                </Carousel.Slide>
              ))}
        </Carousel>
      </div>
    </TopVendorSection>
  );
};
